import React, { useCallback } from 'react'

import { Minus, Plus } from '@phosphor-icons/react'
import { Text } from 'Components/UI'

import { Container, StateProps, StyledButton } from './styles'

type Props = StateProps & {
  value?: number
  onChange?: (value: number) => void
}

function Counter({ disabled, value = 1, onChange }: Props) {
  const handleChange = useCallback(
    (newValue: number) => {
      if (disabled || newValue < 1) return

      onChange?.(newValue)
    },
    [disabled, onChange],
  )

  return (
    <Container>
      <StyledButton
        disabled={value < 2 || disabled}
        onClick={() => handleChange(value - 1)}
      >
        <Minus />
      </StyledButton>

      <Text body2 disabled={disabled} primary={!disabled}>
        {disabled ? 1 : value}
      </Text>

      <StyledButton disabled={disabled} onClick={() => handleChange(value + 1)}>
        <Plus />
      </StyledButton>
    </Container>
  )
}

export default Counter
